<template>
  <!-- 正文 -->
  <div class="liu" v-wechat-title="'银行卡认证'">
    <!-- 银行卡信息 -->
    <div class="color-f-bg margin-t-15">
      <!-- 卡类型 -->
      <div class="margin-l-15">
        <div class="flex-s form-item">
          <div style="width: 95px;">卡类型</div>
          <input type="tel" class="flex-1" v-model.trim="formData.bankName" disabled />
        </div>
        <div class="line" />
      </div>
      <div class="flex-s margin-l-15 form-item">
        <div style="width: 95px;">卡号</div>
        <input type="tel" class="flex-1" v-model.trim="bankCardNo" disabled />
      </div>
    </div>
    <!-- 人脸提示文字 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
      <span>请验证持卡人本人人脸信息</span>
    </div>
    <!-- 人脸识别 -->
    <div class="flex-s page-padding-l-r padding-t-10 padding-b-10 color-f-bg">
      <div style="width: 95px;">人脸识别</div>
      <div class="faceStyle" @click="onCameraImgClick('renLian')">
        <img v-if="renLian.webUrl" class="img" :src="renLian.webUrl" />
        <svg-icon v-else class-name="img" icon-class="camera_face" />
      </div>
    </div>
    <!-- 人脸识别 对比失败 提示 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6" v-show="isFail">
      人脸识别对比失败，请
      <span class="theme-color" @click="resetCameraInfo('renLian'), resetCameraInfo('shouChi')">重新识别</span>或
      <span class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
    </div>
    <!-- 手持提示文字 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
      <span>请验证持卡人本人手持身份证信息</span>
    </div>
    <!-- 手持身份证 -->
    <div class="flex-s page-padding-l-r padding-t-10 padding-b-10 color-f-bg">
      <div style="width: 95px;">
        <div>手持身份</div>
        <div>证正面照</div>
      </div>
      <div class="handFaceStyle" @click="onCameraImgClick('shouChi')">
        <img class="img" :src="shouChi.webUrl || require('@/assets/handheld_example@3x.png')" />
      </div>
    </div>
    <!-- 手持身份证 对比失败 提示 -->
    <div>
      <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
        <span>避免证件与头部重叠，身份证证件内容要清晰可见，完全露出双手手臂</span>
        <span v-show="isFail">，如对比失败，请</span>
        <span v-show="isFail" class="theme-color" @click="resetCameraInfo('renLian'), resetCameraInfo('shouChi')">重新拍照</span>
        <span v-show="isFail">或</span>
        <span v-show="isFail" class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" @click="submitData">提交</mt-button>
    </div>
    <!-- 百度人脸识别弹窗 -->
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
  </div>
</template>

<script>
/* global PUBLIC_TOKEN */
/* global PUBLIC_PRODUCT */
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import Liveness from '@/components/Liveness';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { VerIdCardFace, AuditBankElementsStatus, YMTivingThing } from '@/api/weChat.js';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'LargeAuth',
  components: { SvgIcon, Liveness },
  data() {
    return {
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 云码通人脸识别
      ymt: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 表单数据
      formData: {
        bankName: '',
        bankCardNo: '',
      },
      // 活体认证类型
      faceDetectActivity: 0,
      // 百度人脸弹窗开关
      livingFacePopupVisible: false,
      // 认识是否失败
      isFail: false,
    };
  },
  watch: {
    livingFaceImgUrl(val) {
      this.renLian.base64 = val;
      this.renLian.fileUrl = val;
      this.renLian.webUrl = val;
    },
    livingFacePopupStatus(val) {
      this.livingFacePopupVisible = val;
    },
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus']),
    bankCardNo() {
      return this.formData.bankCardNo.substr(0, 6) + '********' + this.formData.bankCardNo.substr(-4); // 卡号
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.formData.bankName = this.$route.query.bankname;
      this.formData.bankCardNo = this.$route.query.bankcardno;
      this.faceDetectActivity = parseInt(this.$route.query.facedetectactivity);
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.renLian.webUrl = decodeURIComponent(this.$route.query.rlweburl).replace('|', '?');
        this.shouChi.webUrl = decodeURIComponent(this.$route.query.scweburl).replace('|', '?');
        switch (imgType) {
          case 'ymt':
            this.yMTivingThing();
            break;
          case 'renLian':
          case 'shouChi':
            break;
        }
      }
    });
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this.isFail = false;
    },
    // 提交按钮点击
    submitData() {
      if (!this.renLian.webUrl) {
        CusToast('请先进行人脸识别');
        return;
      }
      if (!this.shouChi.webUrl) {
        CusToast('请上传手持身份证照片');
        return;
      }
      CusLoadingOpen();
      VerIdCardFace({
        cardNum: this.formData.bankCardNo,
        url: this.renLian.webUrl,
        isAddHoldIDCard: 1,
        holdIDCardUrl: this.shouChi.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          const msg = SucceedHandle(res.code, res.msg, () => {
            CusAlert(res.msg, () => {
              wx.miniProgram.switchTab({
                url: `/pages/home/home`,
              });
            });
          });
          if (res.code === 9069) {
            CusAlert(res.msg, () => (this.isFail = true));
          } else {
            msg && CusToast(msg);
          }
        })
        .catch(err => {
          CusLoadingClose();
          if ((err.code === 9990 && err.innerCode === 7775) || err.innerCode === 7776) {
            // 自动人工审核
            let msg = err.msg;
            if (err.innerCode === 7776) {
              msg = '今日人脸对比次数已达上限，已为您申请人工审核，预计将在1个工作日内完成审核';
            }
            CusAlert(msg, () => {
              // 1.向小程序发消息，更新状态
              wx.miniProgram.postMessage({ data: { page: 'refresh' } });
              // 2.跳转小程序银行卡认证页面
              wx.miniProgram.redirectTo({
                url: `/pages/bankcardAuth/authIndex?pageTitle=银行卡认证`,
              });
            });
          } else {
            CusAlert(err.msg, () => (this.isFail = true));
          }
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 跳人工审核
    jumpManualAudit() {
      CusAlert('人工审核将在1个工作日内处理完成，是否确定申请人工审核', () => {
        CusAlert('已为您提交人工审核，请继续完成后续认证流程，否则将无法通过人工审核', () => {
          AuditBankElementsStatus({
            cardNum: this.formData.bankCardNo, // 卡号 ,
            faceUrl: this.renLian.webUrl, // 人像url ,
            holdidcard: this.shouChi.webUrl, // 手持照片url
          })
            .then(res => {
              CusLoadingClose();
              const msg = SucceedHandle(res.code, res.msg, () => {
                CusAlert(res.msg, () => {
                  // 1.向小程序发消息，更新状态
                  wx.miniProgram.postMessage({ data: { page: 'refresh' } });
                  // 2.跳转小程序银行卡认证页面
                  wx.miniProgram.redirectTo({
                    url: `/pages/bankcardAuth/authIndex?pageTitle=银行卡认证`,
                  });
                });
              });
              msg && CusToast(msg);
            })
            .catch(err => {
              CusLoadingClose();
              const msg = NotSucceedHandle(err.message);
              msg && CusToast(msg);
            });
        });
      });
    },
    // 跳转人脸识别，人脸识别不同方式不同处理
    jumpToLiveness() {
      let data = null;
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          data = this.createPostMessage('renLian');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          data = this.createPostMessage('ymt');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'LargeAuthen',
        imgType: imgTypeStr,
        bankName: this.formData.bankName,
        bankCardNo: this.formData.bankCardNo,
        rlWebUrl: encodeURIComponent(this.renLian.webUrl.replace('?', '|')),
        scWebUrl: encodeURIComponent(this.shouChi.webUrl.replace('?', '|')),
      };
    },
    // 调用云码通的接口做人脸识别
    yMTivingThing() {
      CusLoadingOpen();
      YMTivingThing({ url: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.renLian.webUrl = this.renLian.webUrl;
            this.renLian.fileUrl = this.renLian.webUrl;
            this.renLian.base64 = this.renLian.webUrl;
          } else {
            CusAlert(res.msg, () => {
              this.renLian.webUrl = '';
              this.renLian.fileUrl = '';
              this.renLian.base64 = '';
            });
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case 'shouChi':
          const data = this.createPostMessage(type);
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 'renLian':
          this.jumpToLiveness();
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-t-15 {
  margin-top: 0.75rem;
}

.form-item {
  line-height: 1;
  padding: 0.6rem 0;

  input[type='tel'] {
    width: 100%;
    font-size: $title3;
    outline: 0;
    padding: 0;
    border: 0;

    &:disabled {
      background-color: $highlight-color;
      color: $word-color;
    }

    &::-webkit-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &::-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-ms-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }
  }

  .code {
    width: 6rem;
    text-align: right;
    padding-right: 0.75rem;
    @include dynamic-color;

    &.disabled {
      color: $explain-color !important;
    }
  }
}

.line {
  height: 1px;
  border-bottom: 1px solid $border-color;
}
</style>
